import { AnyObject } from '@store/types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import styles from './CreationMenuField.module.scss';
import { useFieldCreator } from '@components/Table/CreationMenu/CreationMenuField/hooks/useFieldCreator';
import { FieldTitle, FieldTitleModificator, FieldTitleTheme } from '@components/FieldTitle';
import { TableField } from '@components/Table/CreationMenu';

interface Props {
    menuData: object;
    field: TableField;
    fields: TableField[];
    isMultiField?: boolean;
    onChange(params: object): Promise<void>;
}

const Field = observer(({ field, onChange, fields, menuData }: Props) => {
    const { getField } = useFieldCreator({ field, fields, onChange, menuData });

    return (
        <>
            {field.multiFields ? (
                <div>
                    {!!field.fieldName && (
                        <FieldTitle
                            theme={field.fieldTitleTheme ?? FieldTitleTheme.WithFlex}
                            modificators={[FieldTitleModificator.WithPadding]}
                            title={field.label}
                        />
                    )}
                    <div className={classNames([styles.multiFields, ...(field?.multiFieldModifiers ?? [])])}>
                        {field.multiFields.map(item => (
                            <Field
                                key={`${item.label}_${item.fieldName}`}
                                menuData={menuData}
                                fields={fields}
                                isMultiField
                                field={item}
                                onChange={onChange}
                            />
                        ))}
                    </div>
                </div>
            ) : (
                <div className={classNames([styles.field, ...(field?.fieldModifiers ?? []), field.customStyle])}>
                    {getField({ ...field, value: field.value ?? (menuData as AnyObject)[field.fieldName] })}
                </div>
            )}
        </>
    );
});

export const CreationMenuField = observer((props: Props) => {
    return (
        <div className={classNames([styles.root, props.isMultiField && styles.withoutMargin])}>
            <Field {...props} />
        </div>
    );
});
